// no lodash (because used in redirect.ts)

/**
 * @param urlParamString either window.location.hash or window.location.search
 */
export function getUrlParamDict(urlParamString: string | null = window.location.hash) {
	if (urlParamString === null) return {}
	urlParamString = urlParamString.substr(1);
	return urlParamString.split('&').reduce<Record<string, string>>(function (res, item) {
		const parts = item.split('=')
		const key = parts[0]
		const value = parts[1]
		if (key && value) res[decodeURIComponent(key)] = decodeURIComponent(value)
		return res
	}, {})
}

type UrlParamMap = Record<string, string | number | boolean>

export function getUrlParamString(paramMap: UrlParamMap) {
	return Object.entries(paramMap).map(([k, v]) =>
		encodeURIComponent(k) + '=' + encodeURIComponent(v),
	).join('&')
}

export function getUrlParamStringFull(searchParamMap: UrlParamMap, hashParamMap: UrlParamMap) {
	const s = getUrlParamString(searchParamMap)
	const h = getUrlParamString(hashParamMap)
	return (s ? '?' + s : '') + (h ? '#' + h : '')
}

export function addUrlParam(key: string, value: string | number | null, urlParamString: string = window.location.hash, startChar: string = '#') {
	const dict = getUrlParamDict(urlParamString)
	if (!value && value !== 0) delete dict[key]
	else dict[key] = value + ''
	urlParamString = Object.entries(dict).map(([k, v]) =>
		encodeURIComponent(k) + '=' + encodeURIComponent(v),
	).join('&')
	return urlParamString ? (startChar + urlParamString) : ''
}

export function getAndRemoveParams(keyValueMatcher: (key: string, value: string) => boolean) {
	const sp = getUrlParamDict(window.location.search)
	const ret: Record<string, string> = {}
	const cleanedSP = Object.entries(sp).flatMap(([key, value]) => {
		if (keyValueMatcher(key, value)) {
			ret[key] = value
			delete sp[key]
			return []
		} else {
			return [encodeURIComponent(key) + "=" + encodeURIComponent(value)]
		}
	}).join('&')
	const hp = getUrlParamDict(window.location.hash)
	const cleanedHP = Object.entries(hp).flatMap(([key, value]) => {
		if (keyValueMatcher(key, value)) {
			ret[key] = value
			delete hp[key]
			return []
		} else {
			return [encodeURIComponent(key) + "=" + encodeURIComponent(value)]
		}
	}).join('&')

	let uri = window.location.toString()
	const cut = uri.match(/[?#]/)?.index
	if (cut) uri = uri.substring(0, cut)
	if (cleanedSP) uri += '?' + cleanedSP
	if (cleanedHP) uri += '#' + cleanedHP
	window.history.replaceState({}, window.document.title, uri)
	return ret;
}